"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUANTITY_SELECTOR_NAME = exports.PRODUCT_DETAILS_CLASS = exports.QUANTITY_LIMIT = void 0;
exports.QUANTITY_LIMIT = 10;
exports.PRODUCT_DETAILS_CLASS = 'shop-product-details';
exports.QUANTITY_SELECTOR_NAME = 'order-quantity';
